import { UsersRoundIcon } from "lucide-react";
import { formatNumber } from '@/utils/formatNumber';

interface OccupancyCardProps {
  current: number;
  peopleIn: number;
  peopleOut: number;
}

export function OccupancyCard({ current, peopleIn, peopleOut }: OccupancyCardProps) {
  return (
    <div className="bg-white rounded-[10px] shadow-card p-2 border border-light-grey gap-[8px] flex flex-col h-full">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <div className="h-[18px] w-[18px] bg-light-grey rounded flex items-center justify-center">
            <UsersRoundIcon className="h-3 w-3 text-primary" />
          </div>
          <h3 className="text-dark-blue heading-7">Occupancy</h3>
        </div>
        <div className="flex items-center gap-2">
          <span className="heading-6">{formatNumber(current, 0)}</span>
          <span className="paragraph-12">persons</span>
        </div>
      </div>

      <div className="flex gap-2 flex-1">
        {/* People In */}
        <div className="flex flex-col justify-between flex-1 pt-[6px] pb-[6px] pl-[8px] pr-[8px] bg-bg border border-light-grey rounded-[8px]">
          <div className="paragraph-11 text-dark">People In</div>
          <div className="flex items-baseline gap-1">
            <span className="heading-6">{formatNumber(peopleIn, 0)}</span>
            <span className="paragraph-12">persons</span>
          </div>
        </div>

        {/* People Out */}
        <div className="flex flex-col justify-between flex-1 pt-[6px] pb-[6px] pl-[8px] pr-[8px] bg-bg border border-light-grey rounded-[8px]">
          <div className="paragraph-11 text-dark">People Out</div>
          <div className="flex items-baseline gap-1">
            <span className="heading-6">{formatNumber(peopleOut, 0)}</span>
            <span className="paragraph-12">persons</span>
          </div>
        </div>
      </div>
    </div>
  );
}